<template>
  <div class="bg-white max-w-lg my-4">
    <a-list bordered :data-source="institutions">
      <h3 slot="header" class="text-xl font-semibold">
        FINANCIAL INSTITUTIONS
        <div class="float-right cursor-pointer" @click="notifyAddButtonClick()">
          <font-awesome-icon icon="plus"></font-awesome-icon>
        </div>
      </h3>
      <a-list-item slot="renderItem" slot-scope="item">
        <div class="w-full">
          <span
            class="cursor-pointer text-terracotta hover:underline"
            @click="notifyEditButtonClick(item)"
          >
            {{ item.name }}
          </span>
          <a-popconfirm
            title="Are you sure you want to delete this institution?"
            ok-text="Yes"
            cancel-text="No"
            @confirm="notifyDeleteButtonClick(item.id)"
          >
            <a-icon
              type="delete"
              title="Delete"
              class="mx-2 float-right cursor-pointer text-red-400"
            ></a-icon>
          </a-popconfirm>
          <a-icon
            type="edit"
            title="Edit"
            class="mx-2 float-right cursor-pointer text-terracotta"
            @click="notifyEditButtonClick(item)"
          ></a-icon>
        </div>
      </a-list-item>
    </a-list>
  </div>
</template>

<script>
export default {
  props: {
    institutions: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    notifyAddButtonClick() {
      this.$emit('add-institution')
    },
    notifyDeleteButtonClick(institutionId) {
      this.$emit('delete-institution', institutionId)
    },
    notifyEditButtonClick(institution) {
      this.$emit('edit-institution', institution)
    },
  },
}
</script>

<style></style>
